import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { createCustomElement } from '@angular/elements';
import { CookieService } from 'ngx-cookie-service';
import { NgReduxModule } from '@ptl/angular-redux-store';

import { PtlXhrModule } from '@ptl/xhr';
import { PtlGlobalComponentsModule } from '@ptl/global-components';

import { MaterialGlobalModule } from 'src/app/shared/modules/material-global.module';
import { ZipCountyModalTriggerComponent } from './zip-county-modal/zip-county-modal-trigger/zip-county-modal-trigger.component';
import { ReducersRegistryModule } from 'src/app/shared/modules/reducers-registry.module';
import { ZipCountyInputsComponent } from './zip-county-inputs/zip-county-inputs.component'
import { ZipCountyModalComponent } from './zip-county-modal/zip-county-modal.component';
import { SharedComponentsModule } from '../shared/shared-components.module';
import { PlanSelectionModule } from '../plan-selection/plan-selection.module';
import { StateModuleReadyService } from '@ptl/state';

@NgModule({
  declarations: [
    ZipCountyModalComponent,
    ZipCountyModalTriggerComponent,
    ZipCountyInputsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    BrowserModule,
    BrowserAnimationsModule,
    MaterialGlobalModule,
    NgReduxModule,
    PtlXhrModule,
    PtlGlobalComponentsModule,
    ReducersRegistryModule,
    PlanSelectionModule,
    SharedComponentsModule
  ],
  providers: [CookieService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DemographicsModule {
  constructor(
    private injector: Injector,
    private stateModuleReadyService: StateModuleReadyService
  ) {
    // console.log("DemographicsModule - constructor");
    this.stateModuleReadyService.ready$.subscribe((isReady: boolean) => {
      if (isReady) {
        this.createElementIfDoesNotExist('sxe-zip-county-modal-trigger', ZipCountyModalTriggerComponent);
        this.createElementIfDoesNotExist('sxe-zip-county-inputs', ZipCountyInputsComponent);
      }
    });

  }

  /** Adding these checks in, as during debugging, sometimes the error of previous definition would be thrown */
  createElementIfDoesNotExist(elementName: string, elementComponent: any) {
    if (!customElements.get(elementName)) {
      const customElement = createCustomElement(elementComponent, {
        injector: this.injector
      });
      customElements.define(elementName, customElement);
    }
  }
  ngDoBootstrap() { }
}
